import { telephonyProviders } from "@/src/constants/telephonyConstants";
import { getCountryCode } from "@/src/utils/phoneNumberUtils";
import { countryTelephonyProviderMapping } from "@/src/constants/phoneNumberConstants";

class ProviderManager {
  constructor() {
    this.providerRules = {
      [telephonyProviders.twilio]: {
        enabled: true,
      },
      [telephonyProviders.plivo]: {
        enabled: true,
      },
      [telephonyProviders.plivoInternational]: {
        enabled: true,
      },
    };
    this.endpointToProvider = new Map();
  }

  getProviderForNumber(phoneNumber) {
    if (!phoneNumber) {
      throw new Error("Phone number is required");
    }

    const countryCode = getCountryCode(phoneNumber);
    
    if (!countryCode) {
      throw new Error(`Cannot determine country for number ${phoneNumber}`);
    }

    const provider = countryTelephonyProviderMapping[countryCode];
    
    if (!provider) {
      throw new Error(`No provider configured for country ${countryCode}`);
    }

    console.log(`Provider ${provider} selected for ${countryCode} number ${phoneNumber}`);
    return provider;
  }

  isProviderEnabled(provider) {
    return this.providerRules[provider]?.enabled || false;
  }

  getEnabledProviders() {
    return Object.keys(this.providerRules).filter(
      (provider) => this.providerRules[provider].enabled,
    );
  }

  addProviderRule(provider, rules) {
    this.providerRules[provider] = rules;
  }

  updateProviderRule(provider, rules) {
    if (this.providerRules[provider]) {
      this.providerRules[provider] = {
        ...this.providerRules[provider],
        ...rules,
      };
    }
  }

  setEndpointMapping(endpoint, provider) {
    if (endpoint) {
      this.endpointToProvider.set(endpoint, provider);
      console.log(`Mapped endpoint ${endpoint} to provider ${provider}`);
    }
  }

  getProviderForEndpoint(endpoint) {
    if (this.endpointToProvider.has(endpoint)) {
      return this.endpointToProvider.get(endpoint);
    }
    return null;
  }

  clearEndpointMappings() {
    this.endpointToProvider.clear();
  }
}

export default new ProviderManager();
